export default "__VITE_ASSET__nblny$4m__"